/**
 * Cloud Storage Integration Helpers
 * 
 * To enable cloud storage uploads, add these environment variables to your .env file:
 * 
 * REACT_APP_DROPBOX_APP_KEY=your_dropbox_app_key
 * REACT_APP_GOOGLE_API_KEY=your_google_api_key
 * REACT_APP_GOOGLE_OAUTH_TOKEN=your_google_oauth_token
 * REACT_APP_ONEDRIVE_CLIENT_ID=your_onedrive_client_id
 * REACT_APP_BOX_CLIENT_ID=your_box_client_id
 */

// Load Dropbox Chooser script
export const loadDropboxScript = (appKey) => {
  return new Promise((resolve, reject) => {
    if (window.Dropbox) {
      resolve();
      return;
    }

    const script = document.createElement('script');
    script.src = 'https://www.dropbox.com/static/api/2/dropins.js';
    script.id = 'dropboxjs';
    script.setAttribute('data-app-key', appKey || '');
    script.onload = () => resolve();
    script.onerror = () => reject(new Error('Failed to load Dropbox script'));
    document.body.appendChild(script);
  });
};

// Load Google Picker API
export const loadGooglePicker = () => {
  return new Promise((resolve, reject) => {
    if (window.gapi && window.gapi.picker) {
      resolve();
      return;
    }

    const script = document.createElement('script');
    script.src = 'https://apis.google.com/js/api.js';
    script.onload = () => {
      if (window.gapi) {
        window.gapi.load('auth2', () => {
          window.gapi.load('picker', () => resolve());
        });
      } else {
        reject(new Error('Google API not loaded'));
      }
    };
    script.onerror = () => reject(new Error('Failed to load Google API'));
    document.body.appendChild(script);
  });
};

// Load OneDrive SDK
export const loadOneDriveScript = () => {
  return new Promise((resolve, reject) => {
    if (window.OneDrive) {
      resolve();
      return;
    }

    const script = document.createElement('script');
    script.src = 'https://js.live.net/v7.2/OneDrive.js';
    script.onload = () => resolve();
    script.onerror = () => reject(new Error('Failed to load OneDrive script'));
    document.body.appendChild(script);
  });
};

// Load Box Picker SDK
export const loadBoxScript = () => {
  return new Promise((resolve, reject) => {
    if (window.Box) {
      resolve();
      return;
    }

    const script = document.createElement('script');
    script.src = 'https://cdn01.boxcdn.net/platform/elements/12.0.0/en-US/picker.js';
    script.onload = () => resolve();
    script.onerror = () => reject(new Error('Failed to load Box script'));
    document.body.appendChild(script);
  });
};

